import { PERMISSIONS } from '../auth/permissions/catalog';

/**
 * Permission vocabulary of the Observability module (PRD - Observability,
 * Feature 4): one level to enter the module and read the aggregated runs, another
 * to open a run's detail (turns, transcript, steps and calls).
 *
 * The feature declares them here instead of reaching for the global catalog, so
 * every access rule of the log is readable — and changeable — in one place.
 *
 * The log's own permissions (AGE-362), not `agent.view`: the detail carries the end
 * customer's transcripts, so being able to open an agent must not open its log.
 * Default roles (scripts/migrations/role-permissions.json): the module reaches
 * supervisor, the detail stops at admin, operator gets neither. `can()` is an
 * exact-string lookup against the set the backend sends at login, so a role sees
 * the log only after `seed-permissions-catalog.ts` and `seed-role-permissions.ts`
 * ran in its environment.
 */
export const OBSERVABILITY_PERMISSIONS = {
  /** Enter the module and read the list with its figures. */
  view: PERMISSIONS.observability.view,
  /**
   * Open a run's detail: the page reads it for the rows of both sections — a
   * conversation's turns (AGE-359) and a process run's steps (AGE-360). A UX gate only — the detail
   * read must authorize this permission, and record the access, server-side.
   */
  viewDetail: PERMISSIONS.observability.viewDetail,
} as const;

/** Any permission string of this module. */
export type ObservabilityPermission =
  (typeof OBSERVABILITY_PERMISSIONS)[keyof typeof OBSERVABILITY_PERMISSIONS];
